module.exports = __webpack_public_path__ + "static/media/Inter-Bold.275bfea5.ttf";